import { API, authClient } from '../index';

// Get user info by user id
export const getUserInfoByUserId = (id) => {
	return authClient().get(`${API}/user-info/${id}`);
};
